/**
 * Petstyle24 – Zusammen kaufen (sections/product-bundle.liquid; Go-live-Runde, Wunsch 3, D-055 Nr. 7).
 *
 * <ps-bundle> hält die Varianten-IDs (data-main-id, data-partner-id) und den Block [data-ps-bundle-view]:
 *   - Größenwechsel (Radio name="id" der Größenauswahl im Block): Section über die Section Rendering API neu laden
 *     (Petstyle24.fetchSection, gleiche Herkunft; ?variant=<id>&section_id=<id>, Muster assets/ps-product.js), nur den
 *     Block austauschen (DOMParser über Petstyle24.parseHTML, importNode – kein innerHTML), IDs aus der Antwort übernehmen,
 *     Fokus auf die gewählte Größe zurück. Preise und Summe kommen aus der Antwort (keine Rechnung im Browser).
 *   - „Beides in den Warenkorb“ [data-ps-bundle-add]: nur über Petstyle24.cart.add mit zwei Artikeln in einer Anfrage;
 *     Ansage, Drawer und Fehlertexte übernimmt der Adapter; eine Statuszeile zeigt Erfolg bzw. Fehler (Texte aus dem Markup).
 *     Der Knopf ist bis hierher verborgen (ohne JavaScript bleibt der noscript-Hinweis).
 * Kein eigener Zugriff auf Cart-Routen (Prüfung 19), kein Browser-Speicher, keine Konsole, kein HTML-Einfügen.
 */
(() => {
  'use strict';

  if (customElements.get('ps-bundle')) return;

  const PS = window.Petstyle24;

  class PsBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.pending = 0;
      this.addEventListener('change', (event) => this.onChange(event));
      this.addEventListener('click', (event) => this.onClick(event));
      this.reveal();
    }

    view() {
      return this.querySelector('[data-ps-bundle-view]');
    }

    addButton() {
      return this.querySelector('[data-ps-bundle-add]');
    }

    /* Knopf erst mit laufendem Skript und vorhandenem Adapter zeigen */
    reveal() {
      const button = this.addButton();
      if (button && PS && PS.cart) button.hidden = false;
    }

    onChange(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (target && target.matches('[data-ps-size-selector] input[name="id"]') && target.checked) {
        this.switchVariant(target.value);
      }
    }

    async switchVariant(variantId) {
      if (!PS || typeof PS.fetchSection !== 'function') return;
      const productUrl = PS.sameOriginUrl(this.dataset.productUrl);
      const sectionId = this.dataset.sectionId;
      if (!productUrl || !sectionId) return;
      const url = new URL(productUrl.href);
      url.searchParams.set('variant', variantId);

      const token = this.pending + 1;
      this.pending = token;
      const current = this.view();
      const button = this.addButton();
      const hadFocus = Boolean(current && current.contains(document.activeElement));
      if (current) current.setAttribute('aria-busy', 'true');
      if (button) button.setAttribute('aria-disabled', 'true');

      let html = null;
      try {
        html = await PS.fetchSection(url.href, sectionId);
      } catch (error) {
        html = null;
      }
      if (token !== this.pending) return;

      const doc = html ? PS.parseHTML(html) : null;
      const freshRoot = doc ? doc.querySelector('ps-bundle') : null;
      const fresh = freshRoot ? freshRoot.querySelector('[data-ps-bundle-view]') : null;
      const region = this.view();
      if (!fresh || !region) {
        // Prüferbefund A-2 (Bau-Sitzung 2): wie assets/ps-product.js – bei Ladefehler oder unbrauchbarer Antwort die Seite mit der
        // gewählten Größe neu laden, damit Kachel, Summe und die gesendete Varianten-ID nie auseinanderlaufen
        window.location.assign(url.href);
        return;
      }
      fresh.querySelectorAll('noscript').forEach((node) => node.replaceChildren());
      region.replaceWith(document.importNode(fresh, true));
      this.dataset.mainId = freshRoot.dataset.mainId || '';
      this.dataset.partnerId = freshRoot.dataset.partnerId || '';
      this.reveal();
      if (hadFocus) {
        const checked = this.querySelector('[data-ps-size-selector] input[name="id"]:checked');
        if (checked) checked.focus({ preventScroll: true });
      }
    }

    async onClick(event) {
      const button = event.target instanceof Element ? event.target.closest('[data-ps-bundle-add]') : null;
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      if (!PS || !PS.cart || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const items = [this.dataset.mainId, this.dataset.partnerId].map((id) => ({ id: Number(id), quantity: 1 }));
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      const result = await PS.cart.add(items, 1, { trigger: button });
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      const status = this.querySelector('[data-ps-bundle-status]');
      if (!status) return;
      const message = result && result.ok ? this.dataset.added || '' : (result && result.error) || this.dataset.error || '';
      status.textContent = message;
      status.hidden = message === '';
    }
  }

  customElements.define('ps-bundle', PsBundle);
})();
